module.exports = __webpack_public_path__ + "staticcomp/img/share.91abe5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/16/share.jpg
// module id = ZSLL
// module chunks = 39